import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";

export const createSupportTicket = createAsyncThunk(
    'supportTickets/createSupportTicket',
    async ({supportTicket, token}) => {
        const requestBody = JSON.stringify(supportTicket);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/supportTickets/create`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadAllSupportTickets = createAsyncThunk(
    'supportTickets/loadAllSupportTickets',
    async (token) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/supportTickets`,
            {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadSupportTicketsByBank = createAsyncThunk(
    'supportTickets/loadSupportTicketsByBank',
    async ({bankId, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/supportTickets/${bankId}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadSupportTicketsByUser = createAsyncThunk(
    'supportTickets/loadSupportTicketsByUser',
    async({username, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/supportTickets/${username}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const updateSupportTicket = createAsyncThunk(
    'supportTickets/updateSupportTicket',
    async ({supportTicket, token}) => {
        const requestBody = JSON.stringify(supportTicket);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/supportTickets/update`,
            {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadSupportTicketComments = createAsyncThunk(
    'supportTickets/loadSupportTicketComments',
    async ({supportTicketId, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/supportTicket/${supportTicketId}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response
    }
)

export const supportTicketsSlice = createSlice({
    name: 'supportTickets',
    initialState: {
        loadingSupportTickets: false,
        failedToLoadSupportTickets: false,
        creatingSupportTicket: false,
        failedToCreateSupportTicket: false,
        updatingSupportTicket: false,
        failedToUpdateSupportTicket: false,
        supportTickets: [],
        loadingComments: false,
        failedToLoadComments: false,
        supportTicketComments: []
    },
    reducers: {
        clearSupportTickets: (state) =>{
            return {
                ...state,
                supportTickets: []
            }
        }
    },
    extraReducers: {
        [createSupportTicket.pending]: (state) => {
            return {
                ...state,
                creatingSupportTicket: true,
                failedToCreateSupportTicket: false
            }
        },
        [createSupportTicket.fulfilled]: (state, action) => {
            return {
                ...state,
                creatingSupportTicket: false,
                failedToCreateSupportTicket: false,
                supportTickets: [
                    ...state.supportTickets,
                    action.payload
                ]
            }
        },
        [createSupportTicket.rejected]: (state) => {
            return {
                ...state,
                creatingSupportTicket: false,
                failedToCreateSupportTicket: true
            }
        },
        [loadAllSupportTickets.pending]: (state) => {
            return {
                ...state,
                loadingSupportTickets: true,
                failedToLoadSupportTickets: false,
            }
        },
        [loadAllSupportTickets.fulfilled]: (state, action) => {
            return {
                ...state,
                loadingSupportTickets: false,
                failedToLoadSupportTickets: false,
                supportTickets: action.payload
            }
        },
        [loadAllSupportTickets.rejected]: (state) => {
            return {
                ...state,
                loadingSupportTickets: false,
                failedToLoadSupportTickets: true,
            }
        },
        [loadSupportTicketsByBank.pending]: (state) => {
            return {
                ...state,
                loadingSupportTickets: true,
                failedToLoadSupportTickets: false,
            }
        },
        [loadSupportTicketsByBank.fulfilled]: (state, action) => {
            return {
                ...state,
                loadingSupportTickets: false,
                failedToLoadSupportTickets: false,
                supportTickets: action.payload
            }
        },
        [loadSupportTicketsByBank.rejected]: (state) => {
            return {
                ...state,
                loadingSupportTickets: false,
                failedToLoadSupportTickets: true,
            }
        },
        [loadSupportTicketsByUser.pending]: (state) => {
            return {
                ...state,
                loadingSupportTickets: true,
                failedToLoadSupportTickets: false
            }
        },
        [loadSupportTicketsByUser.fulfilled]: (state, action) => {
            return {
                ...state,
                loadingSupportTickets: false,
                failedToLoadSupportTickets: false,
                supportTickets: action.payload
            }
        },
        [loadSupportTicketsByUser.rejected]: (state) => {
            return {
                ...state,
                loadingSupportTickets: false,
                failedToLoadSupportTickets: true
            }
        },
        [updateSupportTicket.pending]: (state) => {
            return {
                ...state,
                updatingSupportTicket: true,
                failedToUpdateSupportTicket: false
            }
        },
        [updateSupportTicket.fulfilled]: (state, action) => {
            const newSupportTickets = current(state).supportTickets.map(supportTicket => supportTicket.id === action.payload.id ? action.payload : supportTicket);

            return {
                ...state,
                updatingSupportTicket: false,
                failedToUpdateSupportTicket: false,
                supportTickets: newSupportTickets
            }
        },
        [loadSupportTicketComments.pending]: (state) => {
            return {
                ...state,
                loadingComments: true,
                failedToLoadComments: false
            }
        },
        [loadSupportTicketComments.fulfilled]: (state, action) => {
            return {
                ...state,
                loadingComments: false,
                failedToLoadComments: false,
                supportTicketComments: action.payload
            }
        },
        [loadSupportTicketComments.rejected]: (state) => {
            return {
                ...state,
                loadingComments: false,
                failedToLoadComments: true
            }
        }
    }
})

export const supportTicketLoading = (state) => state.supportTickets.loadingSupportTickets;
export const failedToLoadSupportTickets = (state) => state.supportTickets.failedToLoadSupportTickets;
export const creatingSupportTicket = (state) => state.supportTickets.creatingSupportTicket;
export const failedToCreateSupportTicket = (state) => state.supportTickets.failedToCreateSupportTicket;
export const updatingSupportTicket = (state) => state.supportTickets.updatingSupportTicket;
export const failedToUpdateSupportTicket = (state) => state.supportTickets.failedToUpdateSupportTicket;
export const selectSupportTickets = (state) => state.supportTickets.supportTickets;
export const selectSupportTicketComments = (state) => state.supportTickets.supportTicketComments;

export const { clearSupportTickets } = supportTicketsSlice.actions;

export default supportTicketsSlice.reducer;